import { render } from "./CompleteQuestionnaires.vue?vue&type=template&id=425f2b9e"
import script from "./CompleteQuestionnaires.vue?vue&type=script&lang=js"
export * from "./CompleteQuestionnaires.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__